"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { AppWrapper, GlobalSidebar, Header, Main, NotificationBar, SidebarItem, ThemeProvider, } from "@climatepartner/components";
import AvatarSlot from "../AvatarSlot/AvatarSlot";
import { FooterSlot } from "../FooterSlot";
import { LanguagePickerSlot } from "../LanguagePicker";
const renderMenuItems = (items, linkComponent) => {
    if (items === undefined || items?.length === 0)
        return undefined;
    return (_jsx(_Fragment, { children: items.map((item) => (_jsx(SidebarItem, { label: item.label, to: item.to ?? "", icon: item.icon, selected: item.selected, onClick: item.onClick, linkComponent: linkComponent }, item.to))) }));
};
const Layout = ({ header, sidebar, slots, children, theme, linkComponent, actions }) => (_jsx(ThemeProvider, { theme: theme, children: _jsxs(AppWrapper, { children: [_jsx(Header, { slots: {
                    middle: (_jsx(Box, { sx: (theme) => ({
                            justifyContent: "center",
                            paddingLeft: 2,
                            paddingRight: 2,
                            display: "flex",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "calc(100vw - 200px)",
                            [theme.breakpoints.down("md")]: {
                                display: "block",
                            },
                        }), children: header?.slots?.middle })),
                }, logoToLink: header?.logoUrl ?? "/", linkComponent: linkComponent, children: _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", children: [_jsx(LanguagePickerSlot, { slots: slots }), _jsx(AvatarSlot, { slots: slots, header: header, actions: actions })] }) }), _jsx(GlobalSidebar, { currentServiceId: sidebar.currentServiceId, services: sidebar?.services, customMenuForCurrentService: renderMenuItems(sidebar?.customMenuItems, linkComponent), footerMenu: renderMenuItems(sidebar?.footerMenu, linkComponent), linkComponent: linkComponent }), _jsx(Main, { topElement: _jsx(NotificationBar, {}), children: children }), _jsx(FooterSlot, { slots: slots })] }) }));
export default Layout;
//# sourceMappingURL=Layout.js.map